import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AppIcon from "../AppIcon/AppIcon";

const BackNavigationBar = () => {
  const { t } = useTranslation();

  return (
    <nav className="relative z-10 px-6 py-5 border-b border-white/10">
      <div className="max-w-4xl mx-auto flex justify-between items-center gap-4">
        <AppIcon />
        <Link
          to="/"
          className="bg-white/5 hover:bg-white/10 border border-white/20 text-white/80 px-4 py-2 rounded-xl text-sm font-medium transition-all"
        >
          {t("global:back")}
        </Link>
      </div>
    </nav>
  );
};

export default BackNavigationBar;
